export function calculateAge(dateOfBirth: string | undefined | null): number {
  if (!dateOfBirth) return 0
  const dob = new Date(dateOfBirth)
  if (isNaN(dob.getTime())) return 0
  
  const today = new Date()
  let age = today.getFullYear() - dob.getFullYear()
  const monthDiff = today.getMonth() - dob.getMonth()
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age--
  }
  
  return Math.max(0, age)
}

export function formatDateOfBirth(dateOfBirth: string | undefined | null): string {
  if (!dateOfBirth) return ''
  const date = new Date(dateOfBirth)
  if (isNaN(date.getTime())) return ''
  return date.toLocaleDateString()
}